const CRITEO_SCRIPT_URL = 'https://static.criteo.net/js/ld/ld.js';

const deviceType = /iPad/.test( navigator.userAgent ) ? 't' : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test( navigator.userAgent ) ? 'm' : 'd';

const collectIDs = () => {
	const items = [];

	Array.from( document.querySelectorAll( 'ul.apartments li.item a' ) ).forEach( ( it ) => {
		items.push( it.dataset.id );
	} );

	return items;
};

const determineEvent = ( product, eventType ) => {
	const pageEvent = {};

	if ( product )
	{
		pageEvent.event = eventType;
		pageEvent.item = product;

		return pageEvent;
	}
	
	if ( location.pathname === '/' )
	{
		pageEvent.event = 'viewHome';

		return pageEvent;
	}

	const productIDs = collectIDs();

	if ( productIDs.length > 0 )
	{
		pageEvent.event = 'viewList';
		pageEvent.item = productIDs;

		return pageEvent;
	}

	const productCard = document.querySelector( 'article' )
	
	if ( productCard )
	{
		const productID = productCard.dataset.id;
		
		pageEvent.event = 'viewItem';
		pageEvent.item = productID;
	}

	return pageEvent;
};

const pushCriteo = ( pageEvent ) => {
	window.criteo_q.push(
		{ event: 'setAccount', account: 86664 },
		{ event: 'setEmail', email: '' },
		{ event: 'setSiteType', type: deviceType },
		pageEvent
	);
};

export const updateCriteo = ( product, eventType ) => {
	if ( /m18|localhost/.test( location.host ) )
	{
		return;
	}

	window.criteo_q = window.criteo_q || [];
	
	const pageEvent = determineEvent( product, eventType );

	if ( Object.keys( pageEvent ).length === 0 )
	{
		return;
	}

	if ( document.querySelector( 'script[src*="criteo"]' ) )
	{
		pushCriteo( pageEvent );
	}
	else
	{
		const criteoScript = document.createElement( 'script' );

		criteoScript.type = 'text/javascript';
		criteoScript.src = CRITEO_SCRIPT_URL;

		criteoScript.addEventListener( 'load', () => {
			pushCriteo( pageEvent );
		} );

		document.body.appendChild( criteoScript );
	}
};